import TelegramIcon from "./images/affiliate-telegram-icon.png";
import WhatsappIcon from "./images/affiliate-whats-icon.png";
import FacebookIcon from "./images/affiliate-facebook-icon.png";

export const INFINITY = -1;

export enum CURRENTY_ENUM {
  USDT = 1,
  INR = 2,
  BRL = 3,
}

export const CURRENTY_CODE_MAP = {
  [CURRENTY_ENUM.USDT]: 'USDT',
  [CURRENTY_ENUM.INR]: 'INR',
  [CURRENTY_ENUM.BRL]: 'BRL',
}

export const CATEGORY_MAP = {
  // 下注返佣
  BET: 1,
  // 充值
  DEPOSIT: 2,
  // 邀请
  INVITE: 3,
}

export enum DATE_TYPE_MAP {
  // 今天
  TODAY = 1,
  // 昨天
  YESTERDAY = 2,
  // 近3天
  THREE_DAYS = 3,
  // 时间周期
  DATE_RANGE = 4,
}

export const DATE_TYPE_MAP_LABEL = {
  [DATE_TYPE_MAP.TODAY]: 'Today',
  [DATE_TYPE_MAP.YESTERDAY]: 'Yesterday',
  [DATE_TYPE_MAP.THREE_DAYS]: 'Last 3d',
}

export enum PLATE_FORM_ENUM {
  //  facebook whatsapp twitter telegram
  FACEBOOK = 'Facebook',
  WHATSAPP = 'WhatsApp',
  // INSTAGRAM = 'instagram',
  TELEGRAM = 'Telegram',
  // DISCORD = 'discord',
}

export const PLATE_FORM_ICON_MAP = {
  // [PLATE_FORM_ENUM.INSTAGRAM]: InstagramIcon,
  [PLATE_FORM_ENUM.TELEGRAM]: TelegramIcon,
  [PLATE_FORM_ENUM.WHATSAPP]: WhatsappIcon,
  [PLATE_FORM_ENUM.FACEBOOK]: FacebookIcon,
  // [PLATE_FORM_ENUM.DISCORD]: DiscordIcon,
};

export const SHARE_PLATFORM_LIST = [
  {
    platform: PLATE_FORM_ENUM.TELEGRAM,
  },
  {
    platform: PLATE_FORM_ENUM.WHATSAPP,
  },
  {
    platform: PLATE_FORM_ENUM.FACEBOOK,
  },
];

export enum STATUS_ENUM {
  // 待处理
  PENDING = 0,
  // 已领取
  RECEIVED = 1,
}

export const ERROR_CODE = {
  OFF_LINE: 102027,
}

export enum AGENT_ENABLE_STATUS_ENUM  {
  OFF = 0,
  ON = 1,
}

export enum CATEGORY_TYPE {
  REFERRAL_BONUS = "Referral bonus",
  DEPOSIT_REBATE = "Deposit rebate",
  BETTING_REBATE = "Betting rebate",
}

export enum REWARD_RULE_TYPE {
  INVITE = 'Invite',
  DEPOSIT = 'deposit',
  BET = 'bet'
}

export const PAGE_SIZE = 50;